import { RARITIES, type Rarity } from '../../shared/rarity.ts';
import { el } from './dom.ts';

export function rarityBadge(rarity: Rarity, className = 'rarity-badge'): HTMLSpanElement {
  const { label, color } = RARITIES[rarity];
  const badge = el('span', { className, textContent: label });
  badge.style.setProperty('--c', color);
  return badge;
}

export function applyRarityBadge(badge: HTMLElement, rarity: Rarity): void {
  const { label, color } = RARITIES[rarity];
  badge.textContent = label;
  badge.style.setProperty('--c', color);
}
